export default __webpack_public_path__ + "static/media/2.791f8982.png";